export const Bio = {
  name: "Alex Shrestha",
  roles: [
    "Full Stack Developer",
    "AI Software Engineer",
    
     ],
  description:
    " A motivated and versatile developer with a passion for  full-stack development ,AI integration and building modern web and mobile applications.",
  github: "https://github.com/shresthaAlex",
  resume: process.env.PUBLIC_URL + "/resume.pdf",
  linkedin: "https://www.linkedin.com/in/alexstha310/",
  twitter: "https://x.com/alexstha103",
  insta: "https://www.instagram.com/alex_stha310/",
  facebook: "https://www.facebook.com/alex.stha.3107/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React ",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "NextJS",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },

 /*
      {
        name: "Redux",
        image:
          "https://frontcast.ir/wp-content/uploads/2024/04/How-to-Use-Redux-and-Redux-Toolkit.png",
      },
      {
        name: "Zustand",
        image:
          "https://miro.medium.com/1*EcyF7PC9ObkhKIcArLQQ1Q.png",
      },



      {
        name: "Zod",
        image:
          "https://zod.dev/_next/image?url=%2Flogo%2Flogo-glow.png&w=640&q=100",
      },


      {
        name: "Axios",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABIElEQVR4Ae2XAUcEQRiGB3B/JQH0CxJgAYIqEAg5BBApAkEciCCIiMISEhKCIKSqqLrNce3oLtVqttknRosssLu+gX34ALyPmRm+V+UACgiAENDUjwbCvwz1D6AF7CKGy2rl4aoQLifhBAL8ESggxB+hquPBZRaebwwl0IqKDGLL6uwr22sDylBZ4OI0YWokkhc42vmge2fkBVKTsbX85kIfr4QFhrFlZabvAsUFHi4NC+M9FyYuYC2cHX5xsv/pZmmyLylQZKOtG4FGoBEoCLQneqzPx272OkOsFRbIp7Oo+U4y+ROYHo042HyHzMMVzI29cH6c+HkDT9eG7q0B8COQIy3gvt1PSmVKLaXRfUpNaO9rufdi4rua+S+n3uv5LxoSNklgIWvnAAAAAElFTkSuQmCC",
      },



      {
        name: "TanStack Query",
        image:
          "https://res.cloudinary.com/dw6wav4jg/image/upload/v1717914209/1_elhu-42TzQEdsFjKDbQhhA_gv2meq.png",
      },

      {
        name: "Figma",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS62LVhts8-ERiNmlrfHQShVXasUYH38KKSRw&s",
      },

      {
        name: "Play Wright",
        image:
          "https://api.nuget.org/v3-flatcontainer/microsoft.playwright/1.55.0/icon",
      },
       */
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express",
        image:
          "https://www.peanutsquare.com/wp-content/uploads/2024/04/Express.png",
      },

      {
        name: "FastAPI",
        image:
          "https://avatars.githubusercontent.com/u/156354296?s=200&v=4",
      },


      /* {
        name: "Nginx",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAV1BMVEVHcEwNl0cNl0gOl0gMlkYOmEcNl0gNl0gOl0gNl0gNl0gOl0gOl0gHlkYAlUMmnlU1pGHr9/H////K6NdKrnN3wJNTs3qn0bW73skAkTjP6dmBxZxwuottpFM/AAAADXRSTlMAWeAUQbn/j/KC2MCzV8aAaAAAAMFJREFUeAGF0wUSgDAMBECkBK0Fl/9/EwkuGW68W2/jXON6nut8xhcBzAnEh4kwAkoUPtmPEziSxP7V3BRuSd2DRBbBI1EmiPyQSCq5gZTENLcAijZ6U6OBInaUxmJeKABQJVojb6gqRMzNrKpGpF4PxAYkj1i3HDYdYtkyWBcWbdUy2FazGg7bHrFrGIRlTuRQ6oZHUCYnfF6fHZYmWXRotbwiXTxQpL5c/PFkx4up48n4x/7/JvwH+/+aP5+aKYcJ/UsWvyxQz4gAAAAASUVORK5CYII=",
      },
      
      {
        name: "GraphQL",
        image:
          "https://graphql-go.github.io/graphql-go.org/img/GraphQL_Logo.png",
      },*/

      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
    
      
      {
        name: "PostgreSQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/postgresql/postgresql-original.svg",
      },

       {
        name: "MySQL",
        image:
          "https://github.com/user-attachments/assets/b9a84a8a-6097-44c9-9cf3-42a3247f312a",
      },




      
 /*
      

     {
        name: "Convex",
        image:
          "https://img.stackshare.io/service/41143/default_f1d33b63d360437ba28c8ac981dd68d7d2478b22.png",
      },

      {
        name: "Appwrite",
        image:
          "https://appwrite.io/assets/logomark/logo.png",
      },
   
      {
        name: "Mongoose",
        image:
          "https://media.licdn.com/dms/image/v2/D4D12AQEk8opKsyHhRQ/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1693917399837?e=2147483647&v=beta&t=L_IQgiz-aKgF-m3L2lYQxNFCwIKvn09DwxghjuWIF-I",
      },

      {
        name: "Prisma",
        image: "https://avatars.githubusercontent.com/u/17219288?s=200&v=4",
      },

      {
        name: "Postman",
        image:
          "https://uxwing.com/wp-content/themes/uxwing/download/brands-and-social-media/postman-icon.png",
      },
      

      {
        name: "Redis",
        image:
          "https://gbnz.gallerycdn.vsassets.io/extensions/gbnz/redis-cache-clear/2.0.12/1677930191555/Microsoft.VisualStudio.Services.Icons.Default",
      },
      
      {
        name: "Socket.IO",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/9/96/Socket-io.svg",
      }, */
      
    /*{
        name: "Kafka",
        image:
          "https://img-c.udemycdn.com/course/750x422/1146104_b73e_16.jpg",
      },


    
      

      {
        name: "WebRTC",
        image:
          "https://trueconf.com/images/webrtc/header/webrtc-logo.svg",
      },
*/

    
      
    ],
  },
  {
    title: "CI/CD",
    skills: [
      {
        name: "Git",
        image:
          "https://avatars.githubusercontent.com/u/18133?s=280&v=4",
      },

      {
        name: "Github Actions",
        image:
          "https://miro.medium.com/v2/resize:fit:1260/0*Xhd9l-Sd1Yd-diwh.png",
      },
      
      {
        name: "Docker",
        image:
          "https://www.stackhero.io/assets/src/images/servicesLogos/openGraphVersions/docker.png?d87f4381",
      },
/*
      {
        name: "K8s",
        image:
          "https://raw.githubusercontent.com/tandpfun/skill-icons/main/icons/Kubernetes.svg",
      },

      {
        name: "Terraform",
        image:
          "https://img.icons8.com/?size=512&id=kEkT1u7zTDk5&format=png",
      },

      {
        name: "Ansible",
        image:
          "https://logodix.com/logo/1690408.png",
      },

      
      

      {
        name: "Serverless",
        image:
          "https://s3.us-west-2.amazonaws.com/assets.site.serverless.com/open-graph/opengraph-icon-serverless-v2.png",
      },

      

      {
        name: "AWS",
        image:
          "https://kineticit.com.au/wp-content/uploads/2022/10/AWS_logo.png",
      },
     */ 
     
      {
        name: "Vercel",
        image:
          "https://assets.vercel.com/image/upload/front/vercel/twitter-card.png",
      },
      {
        name: "Render",
        image:
          "https://cdn.sanity.io/images/34ent8ly/production/ec37a3660704e1fa2b4246c9a01ab34e145194ad-824x824.png",
      },

      /*
      {
        name: "Prometheus",
        image:
          "https://gimgs2.nohat.cc/thumb/f/640/prometheus-software-logo-prometheus-monitoring--m2i8N4K9K9N4K9K9.jpg",
      },


      {
        name: "Grafana",
        image:
          "https://www.kozhuhds.com/_astro/grafana.3b7f87f7_ZOKT2t.webp",
      },
  */

  
    ],
  },
  {
    title: "Mobile Development",
    skills: [
      {
        name: "ReactNative",
        image:
          "https://engineering.fb.com/wp-content/uploads/2016/04/yearinreview.jpg",
      },
      {
        name: "Expo",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQr5G_XWqJuICwBxkr6DHS4CM1FR00epymzWw&s",
      },
    ],
  },

  {
    title: "AI/ML",
    skills: [
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "LangChain",
        image:
          "https://registry.npmmirror.com/@lobehub/icons-static-png/latest/files/dark/langchain.png",
      },
      {
        name: "LangGraph",
        image:
          "https://registry.npmmirror.com/@lobehub/icons-static-png/latest/files/dark/langgraph.png",
      },

      {
        name: "LangSmith",
        image:
          "https://registry.npmmirror.com/@lobehub/icons-static-png/latest/files/dark/langsmith.png",
      },

   {
        name: "ChromaDB",
        image:
          "https://www.trychroma.com/img/favicon.ico",
      },
      
      
      {
        name: "scikit-learn",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Scikit_learn_logo_small.svg/2560px-Scikit_learn_logo_small.svg.png",
      },
      {
        name: "Pandas",
        image:
          "https://img.icons8.com/?size=512&id=xSkewUSqtErH&format=png",
      },
      {
        name: "Numpy",
        image:
          "https://img.icons8.com/?size=512&id=aR9CXyMagKIS&format=png",
      },
      {
        name: "Matplotlib",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Matplotlib_icon.svg/1024px-Matplotlib_icon.svg.png",
      },
      
      {
        name: "Seaborn",
        image:
          "https://cdn.worldvectorlogo.com/logos/seaborn-1.svg",
      },
     
      
    ],
  },
];

export const experiences = [];

export const education = [
  {
    id: 0,
    img: "https://media.licdn.com/dms/image/v2/C560BAQFkRiv8jDcNpA/company-logo_200_200/company-logo_200_200/0/1630645813662?e=2147483647&v=beta&t=fC_eMr4WIVT67Rx2YPDjBsw-5AXFd_Z9HgcM3yfO3Xw",
    school: "IOE Pulchowk Campus",
    date: "2024 - present",
    desc: "I am currently pursuing a Bachelor's degree in Computer Engineering at IOE Pulchowk Campus.",
    degree: "Bachelor of Engineering - B.E, Computer Engineering",
  },
  {
    id: 1,
    img: "https://i0.wp.com/ccrc.edu.np/wp-content/uploads/2020/06/cropped-ccrc-logo.png?fit=512%2C512&ssl=1",
    school: "CCRC",
    date: "2021 - 2023",
    desc: "I completed my class 12 high school education at CCRC, where I studied Science with Computer Science.",
    degree: "NEB(XII), Science with Computer",
  },
];

export const projects = [


  {
    id: 0,
    title: " LangChat",
    description: "An AI-Powered RAG-Based Agentic Chatbot with MCP.",
    image: "https://i.ibb.co/RpCCJ3Ss/chatbot.jpg",
    tags: ["LanGraph", "LangSmith" ],
    category: ["machine learning", "web app"],
    github: "https://github.com/shresthaAlex/ChatBot",
    webapp: "https://alexchatbot.streamlit.app",
  },



    {
    id: 1,
    title: "Medix",
    description: "A Patient Management System.",
    image: "https://i.ibb.co/pvCrLj11/Screenshot-2025-07-21-170230.png",
    tags: ["Next JS", "FastAPI", "MongoDB", "JWT","Docker", "CI/CD", "Unit Testing"],
    category: [ "web app"],
    github: "https://github.com/shresthaAlex/MedixUI",
    webapp: "https://medix-neon.vercel.app",
  },
  
  {
    id: 2,
    title: "Bondr",
    description: "A  real time chat app.",
    image: "https://i.ibb.co/ZqTwcjk/bondr.jpg",
    tags: ["MERN", "Socket.io",  "JWT"],
    category: ["web app"],
    github: "https://github.com/shresthaAlex/Bondr-Swipe.Chat.Bond",
    webapp: "https://bondr.onrender.com",
  },

   {
    id: 3,
    title: "Swiftly",
    description: "An E-Commerce app.",
    image: "https://i.ibb.co/Z1X8trVr/swiftly.jpg",
    tags: ["MERN", "Redis", "Stripe", "JWT"],
    category: ["web app"],
    github: "https://github.com/shresthaAlex/swiftly-click.shop.smile",
    webapp: "https://swiftly-shop.onrender.com",
  },


  

  {
    id: 4,
    title: "NepalEstate",
    description: "A real estate price prediction app. ",
    image: "https://i.ibb.co/zTvw3T4W/Capture.png",
    tags: ["Machine Learning", "Data Science", "Scikit-learn","NextJS"],
    category: ["machine learning", "web app"],
    github: "https://github.com/shresthaAlex/Nepalestate",
    webapp: "https://nepalestate.vercel.app",
  },
  {
    id: 5,
    title: "CineMatch",
    description:
      "A personalized movie recommendation system.",
    image: "https://i.ibb.co/Y42Tf3Vp/Capture.png",
    tags: ["Machine Learning", "Data Science", "Collaborative-filtering", "Scikit-learn"],
    category: ["machine learning"],
    github: "https://github.com/shresthaAlex/cinematch",
    webapp: "https://cinematch3.streamlit.app",
  },


  {
    id: 6,
    title: "SplitIQ",
    description: "A  shared expenses tracking app.",
    image: "https://i.ibb.co/214s3Ng1/Screenshot-2025-05-09-185044.png",
    tags: ["Next JS", "Gemini API"],
    category: ["machine learning", "web app"],
    github: "https://github.com/shresthaAlex/SplitIQ",
    webapp: "https://splitiq-beige.vercel.app",
  },


  {
    id: 7,
    title: "AlexAI",
    description: "An AI-powered chatbot.",
    image: "https://i.ibb.co/hF24KVJT/Screenshot-2025-05-11-163948.png",
    tags: ["MERN", "TailwindCSS", "Gemini API"],
    category: ["machine learning", "web app"],
    github: "https://github.com/shresthaAlex/AlexAI",
    webapp: "https://alexai-ayn3.onrender.com",
  },


  
  {
  id: 8,
  title: "AVL Tree Visualizer",
  description: "An interactive tool for visualizing AVL Tree.",
  image: "https://i.ibb.co/QjjgP9Xc/ds-avl.png",
    tags: ["Data Structure", "Next JS","React Flow"],
  category: [ "web app"],
  github: "https://github.com/shresthaAlex/AVL-Tree-Visualizer",
  webapp: "https://avl-tree-visualizer-alex.vercel.app",
},
    {
    id: 9,
    title: "Travel Companion AI",
    description: "An AI-powered smart travel planner.",
    image: "https://i.ibb.co/PZHxcTx9/Capture.png",
    tags: ["React", "Gemini API", "SerpAPI"],
    category: ["machine learning", "web app"],
    github: "https://github.com/shresthaAlex/Travel_Companion_AI",
    webapp: "https://travelcompanionai.onrender.com",
  },

    
   

 
 {
    id: 10,
    title: "EasyRyde",
    description: "An app to find your ideal ride effortlessly.",
    image: "https://i.ibb.co/60n3d9cP/af39b36e-0914-4505-8878-f38b3d1bad3a.jpg",
    tags: ["React Native", "EXPO", "Google map"],
    category: ["android app"],
    github: "https://github.com/shresthaAlex/EasyRyde",
    webapp: "https://www.upload-apk.com/en/XFXTAPUgvXDEE0d",
  },




  

];

export const TimeLineData = [{ year: 2024, text: "Started my journey" }];
